import type { MetricDetail } from "contracts/api/metric/responses";
import type { HealthState } from "contracts/enums/core";
import { ThresholdBar } from "../../ui/ThresholdBar";

type Metric = MetricDetail["metric"];

export function ThresholdPanel(props: {
  metric: Metric;
  score: number | null;
  state: HealthState;
}) {
  return (
    <section class="card panel">
      <div class="panel-label">Thresholds</div>
      <ThresholdBar
        score={props.score}
        good={props.metric.good}
        watch={props.metric.watch}
        target={props.metric.target}
        state={props.state}
        height={8}
      />
      <ThresholdRow label="Watch ≥" value={props.metric.watch} />
      <ThresholdRow label="Good ≥" value={props.metric.good} />
      <ThresholdRow label="Target" value={props.metric.target} />
    </section>
  );
}

function ThresholdRow(props: { label: string; value: number }) {
  return (
    <div class="thresh-row">
      <span>{props.label}</span>
      <span>{props.value}</span>
    </div>
  );
}
